/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Swedish
export default {
  'cross-flow-support.back-to-all-products': 'Tillbaka till alla appar',
  'cross-flow-support.close': 'Stäng',
  'cross-flow-support.product-store': 'Appbutik',
};
